export default __webpack_public_path__ + "static/media/mesh-gradient-v2.032cecab.png";